module.exports = __webpack_public_path__ + "static/media/Bilal Gilani.d9d996f7.jpg";